import React from 'react';
import LowboyDispatchFilter from './LowboyDispatchFilter';
import LowboyEquipmentCard from './LowboyEquipmentCard';
import { Col } from 'reactstrap';
import CustomCircularProgress from '../common/CustomCircularProgress';
import { Droppable } from '@hello-pangea/dnd';

export default class LowboyEquipmentPane extends React.Component {
    isVisible = (equipment) => {
        const { selectedEquipmentTypeId, nameFilter } = this.props;

        const regex = new RegExp(nameFilter, 'i');

        return (
            (!selectedEquipmentTypeId ||
                equipment.equipmentTypeId == selectedEquipmentTypeId) &&
            (!nameFilter || equipment.description.match(regex))
        );
    };

    render() {
        const { equipments, equipmentsLoading } = this.props;

        return (
            <div className="equipment-container">
                <Droppable droppableId="equipment-droppable">
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                        >
                            <div className="equipment-pane">
                                <legend className="d-flex flex-row align-items-center">
                                    EQUIPMENT
                                </legend>

                                <LowboyDispatchFilter {...this.props} />

                                <div className="p-2 repeating-content">
                                    {equipmentsLoading && (
                                        <Col className="col-12">
                                            <CustomCircularProgress />
                                        </Col>
                                    )}

                                    {!equipmentsLoading &&
                                        equipments.map((e, i) => (
                                            <Col
                                                key={e.id}
                                                className="col-4"
                                                hidden={!this.isVisible(e)}
                                            >
                                                <LowboyEquipmentCard
                                                    equipment={e}
                                                    index={i}
                                                    {...this.props}
                                                    enableAddressChange={true}
                                                />
                                            </Col>
                                        ))}

                                    {provided.placeholder}
                                </div>
                            </div>
                        </div>
                    )}
                </Droppable>
            </div>
        );
    }
}
